// Copyright (c) 2026 Goffy. All Rights Reserved.

// What tapping a push opens, decided from the data notification-service attached. Kept free of
// native imports so it can be tested and shared by the native and web modules.

/** Opens the Goffy listing in the Play Store app, where an internal tester sees the new build. */
export const PLAY_STORE_URL = 'market://details?id=app.goffy';

export type PushTapAction = { kind: 'route'; href: string } | { kind: 'url'; url: string } | null;

const GUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function actionForPushData(data: unknown): PushTapAction {
  if (!data || typeof data !== 'object') return null;
  const record = data as Record<string, unknown>;
  switch (record.type) {
    case 'round.invite':
      // A GUID check, not just a string check: this becomes a route, and the payload came over the network.
      return typeof record.roundId === 'string' && GUID.test(record.roundId)
        ? { kind: 'route', href: `/round/${record.roundId}/rsvp` }
        : null;
    case 'app.update':
      return { kind: 'url', url: PLAY_STORE_URL };
    default:
      return null;
  }
}
